import arabicUiCopy from "../../statics/arabicUiCopy";
import localization from "../../statics/localization";

export const contentFilterCopy = () =>
  localization.getLanguage() === "arb" ? arabicUiCopy.filter : localization.getLanguage() === "tr"
    ? {
        title: "İçerik görünürlüğü",
        note: "Paketin dışındaki içeriklerin listelerde görünüp görünmeyeceğini seç.",
        label: "Paketimde olmayan içerikleri göster",
        description:
          "Açıkken paketinizde olmayan içerikler de listelenir. Kapalıyken yalnızca izleme hakkınız olan içerikler görünür.",
        on: "Açık",
        off: "Kapalı",
        showingAll: "Paketinizde olmayan içerikler gösteriliyor. İzlemek için uygun paket veya kiralama hakkı gerekir.",
        showingIncluded: "Paketinizde olmayan içerikler gizleniyor.",
        locked:
          "Bu tercih hizmet sağlayıcınız tarafından yönetiliyor. Merkezi kural geçerliyken değiştirilemez.",
        refresh: "Durumu yenile",
        saving: "Tercih kaydediliyor…",
        saved:
          "Tercihin kaydedildi. İçerik listeleri bu tercihe göre güncellenecek.",
        saveError:
          "Tercih kaydedilemedi veya sonucu doğrulanamadı. Yeniden değiştirmeden önce durumu yenile."
      }
    : {
        title: "Content visibility",
        note: "Choose whether to include content outside your packages in listings.",
        label: "Show content outside my packages",
        description:
          "Turn on to include content outside your packages. Turn off to show only content you can watch.",
        on: "On",
        off: "Off",
        showingAll: "Content outside your packages is shown. Watching it requires the appropriate package or rental entitlement.",
        showingIncluded: "Content outside your packages is hidden.",
        locked:
          "Your service provider manages this preference. It cannot be changed while a central rule is active.",
        refresh: "Refresh status",
        saving: "Saving preference…",
        saved: "Preference saved. Content listings will use this setting.",
        saveError:
          "The preference could not be saved or confirmed. Refresh its status before changing it again."
      };
